module.exports = __webpack_public_path__ + "assets/RetinaNarr-Bold.a621a9b7ffb9e2efcf04ace01a882925.woff";